import React, { useMemo } from 'react';
import { generateKey } from '../../utils/utils';

import PDFPage from './PDFPage';
import Skeleton from './Skeleton';

type PDFSectionProps = {
  pages: any[]
};

const PDFSection = ({ pages }: PDFSectionProps) => {
  const renderPDFs = useMemo(() => (
    pages.map((page, idx) => (
      <PDFPage key={generateKey('pdf-page', idx)} page={page} />
    ))
  ), [pages]);


  return (
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      <div className='authorize-request__pdf_container'>
        {pages.length ? (
          renderPDFs
        ) : (
          <Skeleton />
        )}
      </div>
    </div>
  );
};

export default PDFSection;



// WEBPACK FOOTER //
// ./src/components/shared/PDFSection.js